/* Preserve media and playback settings; fetch offscreen video sources before they enter view. */
(() => {
  const observed = new WeakSet();
  const targets = new WeakMap();
  const pending = video => video.hasAttribute('data-mom-src') || !!video.querySelector('source[data-mom-src]');
  function load(video) {
    if (!pending(video)) return;
    observer?.unobserve(video);
    video.preload = 'metadata';
    if (video.dataset.momSrc) {
      video.src = video.dataset.momSrc;
      delete video.dataset.momSrc;
    }
    video.querySelectorAll('source[data-mom-src]').forEach(source => {
      source.src = source.dataset.momSrc;
      delete source.dataset.momSrc;
    });
    video.load();
    if (video.autoplay) video.play().catch(() => {});
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      videosIn(entry.target).forEach(load);
      observer.unobserve(entry.target);
    });
  }, {rootMargin:'1000px 600px', threshold:0}) : null;
  function videosIn(node) {
    if (!(node instanceof Element)) return [];
    return [...(node.matches('video') ? [node] : []), ...node.querySelectorAll('video')];
  }
  function scan(node) {
    videosIn(node).forEach(video => {
      if (!pending(video) || observed.has(video)) return;
      observed.add(video);
      if (!observer) { load(video); return; }
      // Preload the whole rail together, so horizontal scrolling never reveals an unloaded clip.
      const target = video.closest?.('.video-row,#video-reviews-rail') || video;
      targets.set(video, target);
      observer.observe(target);
      const onInteraction = () => load(video);
      video.addEventListener('pointerdown', onInteraction, {once:true,passive:true});
      video.addEventListener('keydown', onInteraction, {once:true});
    });
  }
  scan(document.documentElement);
  new MutationObserver(records => records.forEach(record => {
    record.removedNodes.forEach(node => videosIn(node).forEach(video => observer?.unobserve(targets.get(video) || video)));
    record.addedNodes.forEach(scan);
  })).observe(document.body, {childList:true,subtree:true});
})();
